import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    client: {
      description:
        "Once your first clients added, you'll be able to see their transactions here.",
      title: 'No clients',
    },
    graph: {
      description:
        'We need a little more data before we can help you track your cash flow.',
      title: 'No activity on your account',
    },
    team: {
      description:
        'Once your teams have been invited, you can easily view their expenses here.',
      title: 'No collaborators',
    },
    transactions: {
      description:
        "Once you've made your first spend, they'll be listed and categorized by merchant here.",
      title: 'No transaction',
    },
    unavailableDate: {
      description: 'Additional data will be available in the next few weeks.',
      title: 'Data for the year sought is not yet available',
    },
  },
  fr: {
    client: {
      description:
        'Une fois vos premiers clients ajoutés, vous pourrez facilement visualiser les transactions les concernant ici.',
      title: 'Aucun·e client·e',
    },
    graph: {
      description:
        'Nous avons besoin d’un peu plus de données avant de vous aider à suivre votre trésorerie.',
      title: 'Aucune activité sur votre compte',
    },
    team: {
      description:
        'Une fois vos équipes invitées, vous pourrez visualiser facilement leurs dépenses ici.',
      title: 'Aucun collaborateur',
    },
    transactions: {
      description:
        'Une fois vos premières dépenses réalisées, elles seront répertoriées et catégorisées par marchand ici.',
      title: 'Aucune transaction',
    },
    unavailableDate: {
      description:
        'L’intégralité de vos données sera accessible dans les prochaines semaines.',
      title: "Les données de l'année recherchée ne sont pas encore accessibles",
    },
  },
} as const);

export default locales;
